import { create } from 'zustand';

export type Lang = 'en' | 'zh-CN';

const STORAGE_KEY = 'bsod.locale.lang';

function loadInitial(): Lang {
  if (typeof window === 'undefined') return 'en';
  const v = window.localStorage.getItem(STORAGE_KEY);
  if (v === 'en' || v === 'zh-CN') return v;
  // The console opens in English for everyone; a reader who wants Chinese picks
  // it from the language switch, and that choice is remembered per browser.
  return 'en';
}

interface LocaleState {
  lang: Lang;
  setLang: (lang: Lang) => void;
}

export const useLocaleStore = create<LocaleState>((set) => ({
  lang: loadInitial(),
  setLang: (lang) => {
    if (typeof window !== 'undefined') window.localStorage.setItem(STORAGE_KEY, lang);
    set({ lang });
  },
}));
